import axiosInstance from "../../axios/instance";
import { getToken } from "../../helpers/get-token";

async function createCampaign(values) {
    try {
        const token = getToken();
        const response = await axiosInstance.post('/api/client-campaigns', values, {
            headers: {
                'Authorization': token
            }
        });

        return response?.data;
    } catch (error) {
        console.log(error);
        throw error; // Re-throw the error for further handling if needed
    }
}

export default createCampaign;
